module.exports = __webpack_public_path__ + "img/woman.1c242118.jpeg";